// VFX: MrBeast-Style Lower Third
// Slug: lower_mrbeast-style_bold_2000ms
// Category: lower-thirds
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;
type Props = { title?: string; subtitle?: string; accent?: string };

export default function LowerMrbeastStyleBold2000ms({
  title = "WATCH THIS",
  subtitle = "you won't believe what happens",
  accent = "#facc15",
}: Props) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const sp = spring({
    frame,
    fps,
    config: { stiffness: 220, damping: 14, mass: 0.9, overshootClamping: false },
  });
  const subP = spring({
    frame: frame - 12,
    fps,
    config: { stiffness: 220, damping: 22 },
  });
  return (
    <AbsoluteFill style={{ justifyContent: "flex-end", alignItems: "center", padding: "0 0 220px 0" }}>
      <div
        style={{
          transform: `scale(${interpolate(sp, [0, 1], [0.6, 1], clamp)}) rotate(${interpolate(
            sp,
            [0, 1],
            [-6, 0],
            clamp
          )}deg)`,
          opacity: sp,
        }}
      >
        <div
          style={{
            fontFamily: "Impact, system-ui, sans-serif",
            fontSize: 140,
            fontWeight: 900,
            color: "#fff",
            letterSpacing: 2,
            WebkitTextStroke: `8px #000`,
            textShadow: `10px 10px 0 ${accent}, 14px 14px 0 #000`,
            textTransform: "uppercase",
            lineHeight: 1,
          }}
        >
          {title}
        </div>
      </div>
      <div
        style={{
          marginTop: 24,
          background: accent,
          color: "#000",
          padding: "10px 28px",
          borderRadius: 8,
          fontFamily: "system-ui, sans-serif",
          fontWeight: 800,
          fontSize: 32,
          textTransform: "uppercase",
          opacity: subP,
          transform: `translateY(${interpolate(subP, [0, 1], [20, 0], clamp)}px)`,
          border: "4px solid #000",
        }}
      >
        {subtitle}
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
